import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-contact-banner',
    templateUrl: './contact-banner.component.html',
    styleUrls: ['./contact-banner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
